export interface IDecisionTemplate {
  submissionContextId: string;
  templateId: string;
  text: string;
  label: string;
  type: string;
  subtype?: string;
  templateType: string;
}

export type DecisionTemplateSubtypeKey =
  | 'revisionSeverityOptions'
  | 'rejectionOptions'
  | 'editorialWithdrawalOptions';

export const DECISION_TEMPLATE_TYPE_VALUES = ['RESPONSE_TO_AUTHOR'] as const;
export type DecisionTemplateType =
  (typeof DECISION_TEMPLATE_TYPE_VALUES)[number];

export const DECISION_TEMPLATE_TYPES = {
  RESPONSE_TO_AUTHOR: {
    EditorialRequestImmediateRevision: null,
    RequestRevision: 'revisionSeverityOptions',
    AcceptForFormalAcceptance: null,
    EditorialUnsubmitSubmission: null,
    EditorialWithdrawSubmission: 'editorialWithdrawalOptions',
    EditorialRejectSubmission: 'rejectionOptions',
    ApproveSubmissionForPreProduction: null
  }
} as const satisfies Record<
  DecisionTemplateType,
  Record<string, DecisionTemplateSubtypeKey | null>
>;
export type DecisionTemplateActionType =
  keyof (typeof DECISION_TEMPLATE_TYPES)[DecisionTemplateType];

export const DECISION_TEMPLATE_ACTION_TYPE_VALUES = Object.keys(
  DECISION_TEMPLATE_TYPES.RESPONSE_TO_AUTHOR
) as [DecisionTemplateActionType, ...DecisionTemplateActionType[]];

export type IDecisionTemplateOption = {
  type: DecisionTemplateActionType;
  label: string;
  description: string;
  subtypes: { label: string; type: string }[];
};

export type IJournalConfigurationDecisionTemplatesResponse = {
  decisions: IDecisionTemplateOption[];
};

export type IConfiguredDecisionTemplate = Pick<
  IDecisionTemplate,
  'templateId' | 'text' | 'label' | 'type' | 'subtype' | 'templateType'
>;

export type ISubmissionDecisionTemplate = Pick<
  IDecisionTemplate,
  'templateId' | 'text' | 'label'
>;

export type ISubmissionDecisionTemplateGroup = {
  subtype?: string;
  templates: ISubmissionDecisionTemplate[];
};

export type IDecisionTemplateGroup = {
  type: string;
  subtypes: IDecisionTemplateSubtypeGroup[];
};

export type IJournalConfigurationConfiguredDecisionTemplatesResponse = {
  templates: IDecisionTemplatesByTypeResponse[];
};

export type IDecisionTemplateSubtypeGroup = {
  subtype?: string;
  label?: string;
  templates: IConfiguredDecisionTemplate[];
};

export type IDecisionTemplatesByTypeResponse =
  | {
      type: string;
      label?: string;
      templates: IConfiguredDecisionTemplate[];
    }
  | {
      type: string;
      label?: string;
      subtypes: IDecisionTemplateSubtypeGroup[];
    };
